import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import MainLayout from "./common/layout/MainLayout";
import MainHeader from "./common/layout/main-header";
import MyMenu from "./common/menu/mymenu";
import { PU_RELEATIVE_PATH, RELEATIVE_PATH } from './config';

import Welcome from "./pushUpgrade/componentss/welcome/welcome";
import Callback from "./pushUpgrade/componentss/callback/callback";
import Registration from "./pushUpgrade/componentss/registration/registration";
import ReleaseDetail from "./pushUpgrade/componentss/releaseDetail/releaseDetail";
import Maintenance from "./pushUpgrade/componentss/Maintenance";
import CallbackWithAutoRegistration from "./pushUpgrade/componentss/callback/callbackwithautoregistration";

import { getApiBaseURL } from "./pushUpgrade/common";
import api from "./api";


function App() {

  const [isUnderMaintenance, setUnderMaintenance] = React.useState(true);

  React.useEffect(() => {
    api.get(getApiBaseURL() + "/AdminSettings/GetIsSiteUnderMaintenance").then(res => res.data).then(isUnderMaintenance => {
      setUnderMaintenance(isUnderMaintenance);
      if (isUnderMaintenance) {
        if (window.location.pathname !== `${PU_RELEATIVE_PATH}maintenance`) {
          window.location.href = `${PU_RELEATIVE_PATH}maintenance`;
        }
      } else {
        if (window.location.pathname === `${PU_RELEATIVE_PATH}maintenance`) {
          window.location.href = `${PU_RELEATIVE_PATH}welcome`;
        }
      }
    })
  }, []);


  return (
    <MainLayout>
      <div id="outer-container">
        <div className="container-fulid">
          <div id="menuList">
            <MyMenu />
          </div>
        </div>
        <div id="page-wrap">
          <MainHeader />
          {
            isUnderMaintenance &&
            <Switch>
              <Route exact path={`/`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route exact path={`${RELEATIVE_PATH}`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route exact path={`${PU_RELEATIVE_PATH}`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}welcome`} component={Welcome} />
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}maintenance`} component={Maintenance} />
            </Switch>
          }
          {
            !isUnderMaintenance &&
            <Switch>
              <Route exact path={`/`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route exact path={`${RELEATIVE_PATH}`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route exact path={`${PU_RELEATIVE_PATH}`}>
                <Redirect to={`${PU_RELEATIVE_PATH}welcome`} />
              </Route>
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}welcome`} component={Welcome} />                           
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}callback/:type/autoregistration`} component={CallbackWithAutoRegistration} />
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}callback/:type`} component={Callback} />
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}callback`} component={Callback} />
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}consent-form`} component={Registration} />
              <Route allowAnonymous exact path={`${PU_RELEATIVE_PATH}release-detail`} component={ReleaseDetail} />
            </Switch>
          }
        </div>
        <div className="container-fulid">
        </div>
      </div>
    </MainLayout >
  );
}


export default App;
